import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select } from "@mui/material";
import React from "react";
import {useContext, useState, useEffect} from 'react';
import { ProjectContext } from "../../contexts/ProjectContext";
import AddIcon from '@mui/icons-material/Add';
import { Container, InputLabel, MenuItem } from "@mui/material/node";
import Divider from '@mui/material/Divider';
import { ElementData } from "../../data/elementData";

export const NewNodeDialog = (props) => {
  const [newElement, setNewElement] = useState(ElementData);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [showDefaultFields, setShowDefaultFields] = useState(true);
  const [showDefaultDetails, setShowDefaultDetails] = useState(false);
  const [showContactFields, setShowContactFields] = useState(false);
  const [showContactDetails, setShowContactDetails] = useState(false);
  const [showCompanyFields, setShowCompanyFields] = useState(false);
  const [showCompanyDetails, setShowCompanyDetails] = useState(false);

  const { addNode } = useContext(ProjectContext);

  useEffect(() => {
    handleNodeDetails(null, showAdditionalDetails);
  }, [showAdditionalDetails]);

  const handleAdd = () => {
    console.log("adding " + props.nodetype);
    addNode(newElement, props.nodetype);
    //props.refreshLayout();
    props.handleClose();
  }

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      props.handleClose();
    }
  }

  const handleShowDetailsClick = () => {
    setShowAdditionalDetails(!showAdditionalDetails);
    //handleNodeDetails(null, !showAdditionalDetails);
  }

  const handleNodeDetails = (nodeType, show) => {
    if (!nodeType) {
      nodeType = newElement.nodetype;
    }

    if (!show) {
      show = showAdditionalDetails;
    }

    if (show) {
      setShowDefaultDetails(false);
      setShowContactDetails(false);
      setShowCompanyDetails(false);

      if (nodeType === 1) {
        setShowDefaultDetails(true);
      }
      if (nodeType === 2) {
        setShowContactDetails(true);
      }
      if (nodeType === 3) {
        setShowCompanyDetails(true);
      }
    }
    else {
      setShowDefaultDetails(false);
      setShowCompanyDetails(false);
      setShowContactDetails(false);
    }

    setShowDefaultFields(false);
    setShowContactFields(false);
    setShowCompanyFields(false);

    if (nodeType === 1) {
      setShowDefaultFields(true);
    }
    if (nodeType === 2) {
      setShowContactFields(true);
    }
    if (nodeType === 3) {
      setShowCompanyFields(true);
    }
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setNewElement((prev) => {
      if (e.target.name === "nodetype") {
        handleNodeDetails(e.target.value);
      }
      
      return { ...prev, [name]: value }
    });
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>Add {props?.nodetype === "O" ? "" : props.nodetype?.charAt(0).toUpperCase() + props.nodetype?.slice(1).toLowerCase()} Node</DialogTitle>
        <DialogContent>
          <InputLabel id="demo-select-small-label">Node type</InputLabel>
            <Select
            id="nodetype"
            name="nodetype"
            onChange={handleChange}
            defaultValue={newElement.nodetype}
            fullWidth
            autoFocus
          >
            <MenuItem value={1}>Default</MenuItem>
            <MenuItem value={2}>Person</MenuItem>
            <MenuItem value={3}>Company</MenuItem>
          </Select>
          <Divider sx={{ my: 2 }}></Divider>
          
          {showDefaultFields &&
            <>
              <TextField size="small" required margin="dense" name="name" label="Name" type="text" fullWidth onChange={handleChange} />
            </>}
          
          {showContactFields &&
            <>
              <TextField size="small" margin="dense" name="firstname" label="First name" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" required margin="dense" name="lastname" label="Last name" type="text" fullWidth onChange={handleChange} />
            </>}

          {showCompanyFields &&
            <>
              <TextField size="small" required margin="dense" name="name" label="Company name" type="text" fullWidth onChange={handleChange} />
            </>}
          <Button sx={{ my: 2 }} onClick={handleShowDetailsClick}>{showAdditionalDetails ? "Hide additional details" : "Show additional details"}</Button>
          {showDefaultDetails && 
            <Container>
              <TextField size="small" margin="dense" name="name" label="Description" type="text" multiline rows={2} fullWidth onChange={handleChange} />
            </Container>}

          {showContactDetails &&
            <Container>
              {/* <TextField size="small" required autoFocus margin="dense" name="name" label="Description" type="text" fullWidth onChange={handleChange} /> */}
              <TextField size="small" margin="dense" name="middlename" label="Middle name" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" margin="dense" name="company" label="Company" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" margin="dense" name="position" label="Position" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" margin="dense" name="name" label="Description" type="text" multiline rows={2} fullWidth onChange={handleChange} />
            </Container>}

          {showCompanyDetails &&
            <Container>
              <TextField size="small" margin="dense" name="address" label="Address" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" margin="dense" name="industry" label="Industry" type="text" fullWidth onChange={handleChange} />
              <TextField size="small" margin="dense" name="name" label="Description" type="text" multiline rows={2} fullWidth onChange={handleChange} />
            </Container>}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} variant="outlined">Cancel</Button>
          <Button onClick={handleAdd} variant="contained" color="success" startIcon={<AddIcon />}>Add</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}